import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import styles from './selectable-list.css';
export function SelectableList(props) {
    const { children, className } = props;
    return (_jsx("section", { ...assignTestId('selectable-list', props), className: classNames(styles.listWrapper, className), children: children }));
}
